// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/compatibility/v1/compatibility_api.proto (package gdx.compatibility.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Compatibility, Price, SexualCompatibility, Unavailable } from "./compatibility_pb.js";

/**
 * @generated from message gdx.compatibility.v1.BatchGetCompatibilityStatusesRequest
 */
export class BatchGetCompatibilityStatusesRequest extends Message<BatchGetCompatibilityStatusesRequest> {
  /**
   * @generated from field: repeated string user_ids = 1;
   */
  userIds: string[] = [];

  constructor(data?: PartialMessage<BatchGetCompatibilityStatusesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.BatchGetCompatibilityStatusesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetCompatibilityStatusesRequest {
    return new BatchGetCompatibilityStatusesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetCompatibilityStatusesRequest {
    return new BatchGetCompatibilityStatusesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetCompatibilityStatusesRequest {
    return new BatchGetCompatibilityStatusesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetCompatibilityStatusesRequest | PlainMessage<BatchGetCompatibilityStatusesRequest> | undefined, b: BatchGetCompatibilityStatusesRequest | PlainMessage<BatchGetCompatibilityStatusesRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetCompatibilityStatusesRequest, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.BatchGetCompatibilityStatusesResponse
 */
export class BatchGetCompatibilityStatusesResponse extends Message<BatchGetCompatibilityStatusesResponse> {
  /**
   * @generated from field: map<string, gdx.compatibility.v1.BatchGetCompatibilityStatusesResponse.CompatibilityState> compatibilities = 1;
   */
  compatibilities: { [key: string]: BatchGetCompatibilityStatusesResponse_CompatibilityState } = {};

  constructor(data?: PartialMessage<BatchGetCompatibilityStatusesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.BatchGetCompatibilityStatusesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "compatibilities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: BatchGetCompatibilityStatusesResponse_CompatibilityState} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetCompatibilityStatusesResponse {
    return new BatchGetCompatibilityStatusesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetCompatibilityStatusesResponse {
    return new BatchGetCompatibilityStatusesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetCompatibilityStatusesResponse {
    return new BatchGetCompatibilityStatusesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetCompatibilityStatusesResponse | PlainMessage<BatchGetCompatibilityStatusesResponse> | undefined, b: BatchGetCompatibilityStatusesResponse | PlainMessage<BatchGetCompatibilityStatusesResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetCompatibilityStatusesResponse, a, b);
  }
}

/**
 * Wrapper for oneof compatibilities.
 *
 * @generated from message gdx.compatibility.v1.BatchGetCompatibilityStatusesResponse.CompatibilityState
 */
export class BatchGetCompatibilityStatusesResponse_CompatibilityState extends Message<BatchGetCompatibilityStatusesResponse_CompatibilityState> {
  /**
   * @generated from oneof gdx.compatibility.v1.BatchGetCompatibilityStatusesResponse.CompatibilityState.status
   */
  status: {
    /**
     * @generated from field: gdx.compatibility.v1.Compatibility compatibility = 1;
     */
    value: Compatibility;
    case: "compatibility";
  } | {
    /**
     * @generated from field: gdx.compatibility.v1.Price price = 2;
     */
    value: Price;
    case: "price";
  } | {
    /**
     * @generated from field: gdx.compatibility.v1.Unavailable unavailable = 3;
     */
    value: Unavailable;
    case: "unavailable";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<BatchGetCompatibilityStatusesResponse_CompatibilityState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.BatchGetCompatibilityStatusesResponse.CompatibilityState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "compatibility", kind: "message", T: Compatibility, oneof: "status" },
    { no: 2, name: "price", kind: "message", T: Price, oneof: "status" },
    { no: 3, name: "unavailable", kind: "message", T: Unavailable, oneof: "status" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetCompatibilityStatusesResponse_CompatibilityState {
    return new BatchGetCompatibilityStatusesResponse_CompatibilityState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetCompatibilityStatusesResponse_CompatibilityState {
    return new BatchGetCompatibilityStatusesResponse_CompatibilityState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetCompatibilityStatusesResponse_CompatibilityState {
    return new BatchGetCompatibilityStatusesResponse_CompatibilityState().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetCompatibilityStatusesResponse_CompatibilityState | PlainMessage<BatchGetCompatibilityStatusesResponse_CompatibilityState> | undefined, b: BatchGetCompatibilityStatusesResponse_CompatibilityState | PlainMessage<BatchGetCompatibilityStatusesResponse_CompatibilityState> | undefined): boolean {
    return proto3.util.equals(BatchGetCompatibilityStatusesResponse_CompatibilityState, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.GetCompatibilityStatusRequest
 */
export class GetCompatibilityStatusRequest extends Message<GetCompatibilityStatusRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<GetCompatibilityStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.GetCompatibilityStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCompatibilityStatusRequest {
    return new GetCompatibilityStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCompatibilityStatusRequest {
    return new GetCompatibilityStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCompatibilityStatusRequest {
    return new GetCompatibilityStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCompatibilityStatusRequest | PlainMessage<GetCompatibilityStatusRequest> | undefined, b: GetCompatibilityStatusRequest | PlainMessage<GetCompatibilityStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetCompatibilityStatusRequest, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.GetCompatibilityStatusResponse
 */
export class GetCompatibilityStatusResponse extends Message<GetCompatibilityStatusResponse> {
  /**
   * @generated from oneof gdx.compatibility.v1.GetCompatibilityStatusResponse.status
   */
  status: {
    /**
     * @generated from field: gdx.compatibility.v1.Compatibility compatibility = 1;
     */
    value: Compatibility;
    case: "compatibility";
  } | {
    /**
     * @generated from field: gdx.compatibility.v1.Price price = 2;
     */
    value: Price;
    case: "price";
  } | {
    /**
     * @generated from field: gdx.compatibility.v1.Unavailable unavailable = 3;
     */
    value: Unavailable;
    case: "unavailable";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<GetCompatibilityStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.GetCompatibilityStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "compatibility", kind: "message", T: Compatibility, oneof: "status" },
    { no: 2, name: "price", kind: "message", T: Price, oneof: "status" },
    { no: 3, name: "unavailable", kind: "message", T: Unavailable, oneof: "status" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCompatibilityStatusResponse {
    return new GetCompatibilityStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCompatibilityStatusResponse {
    return new GetCompatibilityStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCompatibilityStatusResponse {
    return new GetCompatibilityStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCompatibilityStatusResponse | PlainMessage<GetCompatibilityStatusResponse> | undefined, b: GetCompatibilityStatusResponse | PlainMessage<GetCompatibilityStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetCompatibilityStatusResponse, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.ActivateCompatibilityStatusRequest
 */
export class ActivateCompatibilityStatusRequest extends Message<ActivateCompatibilityStatusRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<ActivateCompatibilityStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.ActivateCompatibilityStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateCompatibilityStatusRequest {
    return new ActivateCompatibilityStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateCompatibilityStatusRequest {
    return new ActivateCompatibilityStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateCompatibilityStatusRequest {
    return new ActivateCompatibilityStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateCompatibilityStatusRequest | PlainMessage<ActivateCompatibilityStatusRequest> | undefined, b: ActivateCompatibilityStatusRequest | PlainMessage<ActivateCompatibilityStatusRequest> | undefined): boolean {
    return proto3.util.equals(ActivateCompatibilityStatusRequest, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.ActivateCompatibilityStatusResponse
 */
export class ActivateCompatibilityStatusResponse extends Message<ActivateCompatibilityStatusResponse> {
  constructor(data?: PartialMessage<ActivateCompatibilityStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.ActivateCompatibilityStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateCompatibilityStatusResponse {
    return new ActivateCompatibilityStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateCompatibilityStatusResponse {
    return new ActivateCompatibilityStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateCompatibilityStatusResponse {
    return new ActivateCompatibilityStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateCompatibilityStatusResponse | PlainMessage<ActivateCompatibilityStatusResponse> | undefined, b: ActivateCompatibilityStatusResponse | PlainMessage<ActivateCompatibilityStatusResponse> | undefined): boolean {
    return proto3.util.equals(ActivateCompatibilityStatusResponse, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.GetSexualCompatibilityStatusRequest
 */
export class GetSexualCompatibilityStatusRequest extends Message<GetSexualCompatibilityStatusRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<GetSexualCompatibilityStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.GetSexualCompatibilityStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSexualCompatibilityStatusRequest {
    return new GetSexualCompatibilityStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSexualCompatibilityStatusRequest {
    return new GetSexualCompatibilityStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSexualCompatibilityStatusRequest {
    return new GetSexualCompatibilityStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSexualCompatibilityStatusRequest | PlainMessage<GetSexualCompatibilityStatusRequest> | undefined, b: GetSexualCompatibilityStatusRequest | PlainMessage<GetSexualCompatibilityStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetSexualCompatibilityStatusRequest, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.GetSexualCompatibilityStatusResponse
 */
export class GetSexualCompatibilityStatusResponse extends Message<GetSexualCompatibilityStatusResponse> {
  /**
   * @generated from oneof gdx.compatibility.v1.GetSexualCompatibilityStatusResponse.status
   */
  status: {
    /**
     * @generated from field: gdx.compatibility.v1.SexualCompatibility sexual_compatibility = 1;
     */
    value: SexualCompatibility;
    case: "sexualCompatibility";
  } | {
    /**
     * @generated from field: gdx.compatibility.v1.Price price = 2;
     */
    value: Price;
    case: "price";
  } | {
    /**
     * @generated from field: gdx.compatibility.v1.Unavailable unavailable = 3;
     */
    value: Unavailable;
    case: "unavailable";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<GetSexualCompatibilityStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.GetSexualCompatibilityStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sexual_compatibility", kind: "message", T: SexualCompatibility, oneof: "status" },
    { no: 2, name: "price", kind: "message", T: Price, oneof: "status" },
    { no: 3, name: "unavailable", kind: "message", T: Unavailable, oneof: "status" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSexualCompatibilityStatusResponse {
    return new GetSexualCompatibilityStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSexualCompatibilityStatusResponse {
    return new GetSexualCompatibilityStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSexualCompatibilityStatusResponse {
    return new GetSexualCompatibilityStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSexualCompatibilityStatusResponse | PlainMessage<GetSexualCompatibilityStatusResponse> | undefined, b: GetSexualCompatibilityStatusResponse | PlainMessage<GetSexualCompatibilityStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetSexualCompatibilityStatusResponse, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.BatchGetSexualCompatibilityStatusesRequest
 */
export class BatchGetSexualCompatibilityStatusesRequest extends Message<BatchGetSexualCompatibilityStatusesRequest> {
  /**
   * @generated from field: repeated string user_ids = 1;
   */
  userIds: string[] = [];

  constructor(data?: PartialMessage<BatchGetSexualCompatibilityStatusesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.BatchGetSexualCompatibilityStatusesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetSexualCompatibilityStatusesRequest {
    return new BatchGetSexualCompatibilityStatusesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetSexualCompatibilityStatusesRequest {
    return new BatchGetSexualCompatibilityStatusesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetSexualCompatibilityStatusesRequest {
    return new BatchGetSexualCompatibilityStatusesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetSexualCompatibilityStatusesRequest | PlainMessage<BatchGetSexualCompatibilityStatusesRequest> | undefined, b: BatchGetSexualCompatibilityStatusesRequest | PlainMessage<BatchGetSexualCompatibilityStatusesRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetSexualCompatibilityStatusesRequest, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.BatchGetSexualCompatibilityStatusesResponse
 */
export class BatchGetSexualCompatibilityStatusesResponse extends Message<BatchGetSexualCompatibilityStatusesResponse> {
  /**
   * @generated from field: map<string, gdx.compatibility.v1.BatchGetSexualCompatibilityStatusesResponse.CompatibilityState> compatibilities = 1;
   */
  compatibilities: { [key: string]: BatchGetSexualCompatibilityStatusesResponse_CompatibilityState } = {};

  constructor(data?: PartialMessage<BatchGetSexualCompatibilityStatusesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.BatchGetSexualCompatibilityStatusesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "compatibilities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: BatchGetSexualCompatibilityStatusesResponse_CompatibilityState} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetSexualCompatibilityStatusesResponse {
    return new BatchGetSexualCompatibilityStatusesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetSexualCompatibilityStatusesResponse {
    return new BatchGetSexualCompatibilityStatusesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetSexualCompatibilityStatusesResponse {
    return new BatchGetSexualCompatibilityStatusesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetSexualCompatibilityStatusesResponse | PlainMessage<BatchGetSexualCompatibilityStatusesResponse> | undefined, b: BatchGetSexualCompatibilityStatusesResponse | PlainMessage<BatchGetSexualCompatibilityStatusesResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetSexualCompatibilityStatusesResponse, a, b);
  }
}

/**
 * Wrapper for oneof compatibilities.
 *
 * @generated from message gdx.compatibility.v1.BatchGetSexualCompatibilityStatusesResponse.CompatibilityState
 */
export class BatchGetSexualCompatibilityStatusesResponse_CompatibilityState extends Message<BatchGetSexualCompatibilityStatusesResponse_CompatibilityState> {
  /**
   * @generated from oneof gdx.compatibility.v1.BatchGetSexualCompatibilityStatusesResponse.CompatibilityState.status
   */
  status: {
    /**
     * @generated from field: gdx.compatibility.v1.SexualCompatibility sexual_compatibility = 1;
     */
    value: SexualCompatibility;
    case: "sexualCompatibility";
  } | {
    /**
     * @generated from field: gdx.compatibility.v1.Price price = 2;
     */
    value: Price;
    case: "price";
  } | {
    /**
     * @generated from field: gdx.compatibility.v1.Unavailable unavailable = 3;
     */
    value: Unavailable;
    case: "unavailable";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<BatchGetSexualCompatibilityStatusesResponse_CompatibilityState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.BatchGetSexualCompatibilityStatusesResponse.CompatibilityState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sexual_compatibility", kind: "message", T: SexualCompatibility, oneof: "status" },
    { no: 2, name: "price", kind: "message", T: Price, oneof: "status" },
    { no: 3, name: "unavailable", kind: "message", T: Unavailable, oneof: "status" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetSexualCompatibilityStatusesResponse_CompatibilityState {
    return new BatchGetSexualCompatibilityStatusesResponse_CompatibilityState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetSexualCompatibilityStatusesResponse_CompatibilityState {
    return new BatchGetSexualCompatibilityStatusesResponse_CompatibilityState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetSexualCompatibilityStatusesResponse_CompatibilityState {
    return new BatchGetSexualCompatibilityStatusesResponse_CompatibilityState().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetSexualCompatibilityStatusesResponse_CompatibilityState | PlainMessage<BatchGetSexualCompatibilityStatusesResponse_CompatibilityState> | undefined, b: BatchGetSexualCompatibilityStatusesResponse_CompatibilityState | PlainMessage<BatchGetSexualCompatibilityStatusesResponse_CompatibilityState> | undefined): boolean {
    return proto3.util.equals(BatchGetSexualCompatibilityStatusesResponse_CompatibilityState, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.ActivateSexualCompatibilityStatusRequest
 */
export class ActivateSexualCompatibilityStatusRequest extends Message<ActivateSexualCompatibilityStatusRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<ActivateSexualCompatibilityStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.ActivateSexualCompatibilityStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateSexualCompatibilityStatusRequest {
    return new ActivateSexualCompatibilityStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateSexualCompatibilityStatusRequest {
    return new ActivateSexualCompatibilityStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateSexualCompatibilityStatusRequest {
    return new ActivateSexualCompatibilityStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateSexualCompatibilityStatusRequest | PlainMessage<ActivateSexualCompatibilityStatusRequest> | undefined, b: ActivateSexualCompatibilityStatusRequest | PlainMessage<ActivateSexualCompatibilityStatusRequest> | undefined): boolean {
    return proto3.util.equals(ActivateSexualCompatibilityStatusRequest, a, b);
  }
}

/**
 * @generated from message gdx.compatibility.v1.ActivateSexualCompatibilityStatusResponse
 */
export class ActivateSexualCompatibilityStatusResponse extends Message<ActivateSexualCompatibilityStatusResponse> {
  constructor(data?: PartialMessage<ActivateSexualCompatibilityStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.ActivateSexualCompatibilityStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateSexualCompatibilityStatusResponse {
    return new ActivateSexualCompatibilityStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateSexualCompatibilityStatusResponse {
    return new ActivateSexualCompatibilityStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateSexualCompatibilityStatusResponse {
    return new ActivateSexualCompatibilityStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateSexualCompatibilityStatusResponse | PlainMessage<ActivateSexualCompatibilityStatusResponse> | undefined, b: ActivateSexualCompatibilityStatusResponse | PlainMessage<ActivateSexualCompatibilityStatusResponse> | undefined): boolean {
    return proto3.util.equals(ActivateSexualCompatibilityStatusResponse, a, b);
  }
}

